export function errorApi(err, genericError) {
  if (!genericError) {
    genericError = 'Falha ao buscar os dados! Tente novamente.'
  }
  let customError = genericError
  const hasErrorResponseData = err.response && err.response.data
  if (hasErrorResponseData) {
    const data = err.response.data
    const errors = data.errors
    if (errors && errors.length) {
      customError = ''
      errors.forEach((error) => {
        customError = customError + error.message + '\n'
      })
    } else if (data.message) customError = data.message
  }
  return customError
}
